import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding: 8px 10px;
`;
